import isNumber from 'lodash/isNumber';

const toCamelCase = (str = '') =>
  str
    .split('-')
    .map((s, index) => {
      if (index === 0) {
        return s;
      }

      return `${s.charAt(0).toUpperCase()}${s.slice(1)}`;
    })
    .join('');

export const pageLoadMetrics = (
  window,
  options = {
    lookupConnectTime: true,
    firstLastByte: true,
    domTiming: true,
    chromeMetrics: true,
    coreWebVitals: true,
  },
) => {
  if (!window || !window.performance || !window.performance.timing) {
    return [];
  }

  const elapsedTime = (endTime, startTime) =>
    startTime > 0 && endTime > 0 ? endTime - startTime : null;
  const { timing } = window.performance;

  let paintMetrics = {};

  if (
    window.performance.getEntriesByType &&
    typeof window.performance.getEntriesByType === 'function'
  ) {
    paintMetrics = window.performance
      .getEntriesByType('paint')
      .reduce((metrics, { name, startTime }) => {
        metrics[`${toCamelCase(name)}Time`] = startTime;
        return metrics;
      }, {});
  }

  const pageLoadTime = {
    ...(options.lookupConnectTime
      ? {
          dnsLookupTime: elapsedTime(timing.domainLookupEnd, timing.fetchStart),
          connectTime: elapsedTime(timing.connectEnd, timing.fetchStart),
        }
      : {}),
    ...(options.firstLastByte
      ? {
          firstByteOfResponseTime: elapsedTime(
            timing.responseStart,
            timing.fetchStart,
          ),
          lastByteOfResponseTime: elapsedTime(
            timing.responseEnd,
            timing.fetchStart,
          ),
        }
      : {}),
    ...(options.domTiming
      ? {
          domInteractiveTime: elapsedTime(
            timing.domInteractive,
            timing.fetchStart,
          ),
          domContentLoadedEndTime: elapsedTime(
            timing.domContentLoadedEventEnd,
            timing.fetchStart,
          ),
          domCompleteTime: elapsedTime(timing.domComplete, timing.fetchStart),
          loadTime: elapsedTime(timing.loadEventEnd, timing.fetchStart),
        }
      : {}),
    ...(options.chromeMetrics
      ? {
          ...paintMetrics,
        }
      : {}),
  };

  const MINUTE = 60 * 1000;
  const invalidMetrics = Object.getOwnPropertyNames(pageLoadTime).filter(
    (metricName) =>
      !isNumber(pageLoadTime[metricName]) ||
      pageLoadTime[metricName] < 0 ||
      pageLoadTime[metricName] > 5 * MINUTE,
  );

  if (invalidMetrics.length > 0) {
    return [];
  }

  return Object.getOwnPropertyNames(pageLoadTime).map((stage) => ({
    stage,
    duration: pageLoadTime[stage],
  }));
};



// WEBPACK FOOTER //
// ./src/metrics/lib/pageLoadMetrics.js